import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { FluentProvider, Toaster } from "@fluentui/react-components";
import { lox24LightTheme } from "../theme/lox24Theme";
import { TOASTER_ID } from "../toaster";
import { initI18n } from "../i18n";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  // Inside onReady so Office.context.displayLanguage is available: the add-in
  // follows whatever language Outlook is running in, with no setting to find.
  // Awaited so the first paint is in the user's language, not English.
  void initI18n().then(() =>
    root?.render(
      <FluentProvider theme={lox24LightTheme}>
        <App />
        <Toaster toasterId={TOASTER_ID} position="top-end" timeout={3000} pauseOnHover />
      </FluentProvider>
    )
  );
});
